import { render } from "./ElectronScanner.vue?vue&type=template&id=713d631a"
import script from "./ElectronScanner.vue?vue&type=script&lang=js"
export * from "./ElectronScanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__